const KEY1 = 'get:dialogs';
const KEY2 = 'get:dialog_current';
const KEY3 = 'concat:dialog_current';
const KEY4 = 'reset:dialog_current';
const KEY5 = 'unconcat:dialog_current';
const KEY6 = 'empty:someone_unread';
const KEY7 = 'set:has_more';
// const KEY8 = 'set:page';
const KEY9 = 'concat:dialogs';
const KEY10 = 'reset:dialogs';
const KEY11 = 'remove:dialog';
const KEY12 = 'remove:dialog_unread';

import {
    GET_MESSAGE_DIALOGS ,
    GET_MESSAGE_MESSAGES ,
} from '../api/config'
import * as $http from '../api/fetch'

export const state = () => {
    return {
        dialogs: [],
        dialog_current: [],
        has_more:0,
    };
};

export const mutations = {
    [KEY1](state, val) {
        state.dialogs = val;
    },
    [KEY2](state, val) {
        state.dialog_current = val;
    },
    [KEY3](state, val) {
        state.dialog_current = state.dialog_current.concat(val);
    },
    [KEY4](state) {
        state.dialog_current = [];
    },
    [KEY5](state, val) {
        val.reverse().forEach(function (v, k) {
            state.dialog_current.unshift(v)
        })
    },
    [KEY6](state, val) {
        state.dialogs.forEach((v, k) => {
            if(v.user.user_id == val){
                v.unread_count = 0
            }
        })
    },
    [KEY7](state,val) {
        state.has_more = val;
    },
    // [KEY8](state) {
    //     state.page = val;
    // },
    [KEY9](state, val) {
        state.dialogs = state.dialogs.concat(val);
    },
    [KEY10](state) {
      state.dialog_current = [];
    },
    [KEY11](state, val) {
      state.dialogs.forEach((v, k) => {
        if(v.user.user_id == val){
          state.dialogs.splice(k,1)
        }
      })
    },
    [KEY12](state, val) {
      state.dialogs.forEach((v, k) => {
        if(k == val){
          state.dialogs[k].unread_count = 0;
        }
      })
    },
};

export const actions = {
    async [KEY1]({commit, state}, params = {}) {
        try {
            if ($http.is_run(GET_MESSAGE_DIALOGS)) {
                return false
            }
            let data = await $http.$axios(GET_MESSAGE_DIALOGS, params)
            if (data.ec == 200) {
                commit(params.page > 1 ? KEY9 : KEY1, data.data.list)
                commit(KEY7, data.data.has_more)
            }
        }
        catch (e) {
            console.log(`error in ${KEY1}`);
            console.log(e);
        }
    },
    async [KEY2]({commit}, params = {}) {
        try {
            if ($http.is_run(GET_MESSAGE_MESSAGES)) {
                return false
            }
            let data = await $http.$axios(GET_MESSAGE_MESSAGES, params)
            if (data.ec == 200) {
                commit(KEY2, data.data.list)

            }
        }
        catch (e) {
            console.log(`error in ${KEY1}`);
            console.log(e);
        }
    },
    // [KEY2]({commit}, dialogs = []) {
    //     commit(KEY2, dialogs)
    // },
    [KEY3]({commit}, dialogs = []) {
        commit(KEY3, dialogs)
    },
    [KEY4]({commit}) {
        commit(KEY4)
    },
    [KEY5]({commit}, dialogs = []) {
        commit(KEY5, dialogs)
    },
    [KEY6]({commit}, user_id = '') {
        commit(KEY6, user_id)
    },
    [KEY7]({commit}, has_more = 0) {
        commit(KEY7, has_more)
    },
    // [KEY8]({commit}, page = 1) {
    //     commit(KEY8, page)
    // },
    [KEY9]({commit}, new_dialogs = []) {
        commit(KEY9, new_dialogs)
    },
    [KEY10]({commit}) {
      commit(KEY10)
    },
    [KEY11]({commit}, user_id = '') {
      commit(KEY11, user_id)
    },
    [KEY12]({commit}, msg_index = -1) {
      commit(KEY12, msg_index)
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};